export default "__VITE_ASSET__DiN2ELrR__"